import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./design/element.less";
import "./design/aistyle.less";

import VueLazyload from 'vue-lazyload';

// 全局组件注册
import registerGlobComp from "./components/registerGlobComp";
// 路由守卫
import { setupRouterGuard } from "./router/guard";

import "@/directives/index";
import "@/filters/index";

import "@/assets/css/normalize.css";

Vue.use(ElementUI);

registerGlobComp(Vue);

setupRouterGuard(router);

Vue.use(VueLazyload);

Vue.config.productionTip = false;

(window as any).HZMD_ENV = process.env.NODE_ENV;

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount("#app");


import Event, { EventEnum } from '@/EventEmeitter'
// 鼠标按下事件全局通知
document.onmousedown = function(e: any) {
	Event.emit(EventEnum.GLOBAL_MOUSE_DOWN, e);
};
